<template>
  <div>
    <div class="comments">
      <div class="header">
        <p v-if="companyName !== ''">Comments for {{ companyName }}</p>

        <span @click="$emit('closeModal')">
          <v-icon class="icon"> close </v-icon>
        </span>
      </div>
      <div class="comments-container" ref="comments_container">
        <ul v-if="!loading">
          <div v-for="group in Object.keys(groupedComments)" :key="group">
            <div v-if="groupedComments[group].length > 0" class="group-divider">
              {{ group }}
            </div>
            <Comment
              v-for="comment in groupedComments[group]"
              :key="comment.id"
              :comment="comment"
              @changed="fetchComments"
            />
          </div>
          <div class="empty-comment"></div>
        </ul>
        <ul class="skeleton-loader" v-else>
          <skeleton-loader
            v-for="i in 5"
            :key="i"
            rounded
            radius="30"
            type="rect"
            :width="376"
            :height="100"
            animation="wave"
            :class="[
              { author_is_current: i % 2 == 0 },
              { 'other-author': i % 2 != 0 },
            ]"
          />
        </ul>
      </div>
      <div class="footer" id="footerTextArea">
        <textarea
          ref="commentForm"
          type="text"
          v-model="form.body"
          size="sm"
          id="textArea"
          @input="getCursorPosition"
          @keydown.enter.exact.prevent="addNewComment"
          @keydown.enter.shift.exact.prevent="newLine"
          @keydown.tab.exact ="enterUserSelector"          
        />
        <ul
          :class="['user-selector', { visible: showUserMenu }]"
          :style="`--left: ${userMenuPosition.left}; --top: ${userMenuPosition.top};`"
          ref="userSelectorMenu"
        >
          <li
            v-for="user in keepersUsers"
            :key="user.id"
            tabindex="0"
            @click="mentionUser(replace(user.name, '| Keepers'), user.email)"
            @keydown.enter="mentionUser(replace(user.name, '| Keepers'), user.email)"
            @keydown.38="previousElement"
            @keydown.40="nextElement"
          >
            {{ replace(user.name, "| Keepers") }}
          </li>
        </ul>
        <button class="btn btn-primary" @click="addNewComment">
          <IconSendComment v-if="!submittingComment" />
          <IconSendingComment v-else />
        </button>
      </div>
    </div>
    <div class="modal-background" @click="$emit('closeModal')"></div>
  </div>
</template>

<script>
import IconSendingComment from "./IconSendingComment.vue";
import IconSendComment from "./IconSendComment.vue";
import Comment from "./Comment.vue";
import axios from "axios";
import SkeletonLoader from "skeleton-loader-vue";
import getCaretCoordinates from "textarea-caret";
export default {
  components: { Comment, SkeletonLoader, IconSendComment, IconSendingComment },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    statusId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    "form.body"() {
       if (this.form.body === ""){
        this.resetMention();
        this.resetFooter();
      }
      if (this.form.body.includes("@")) {
        let formBodyArray = this.form.body.split(" ");
        let bodyAfterLastMention = formBodyArray.slice(this.indexOfOngoingMention) // Removes everything before the last mention from the formBodyArray
        let searchTerm = bodyAfterLastMention[bodyAfterLastMention.length - 1];

        if (bodyAfterLastMention.findIndex(element => element.includes("@")) === 0) {
          this.startMentionEvent(formBodyArray, searchTerm);
          searchTerm = this.isSearchTermEmpty(searchTerm, bodyAfterLastMention);
          this.getUsers(searchTerm);
        }
        else{
          this.resetMention();
        }
      }
    },
  },
  computed: {
    groupedComments() {
      if (this.comments.length > 0) {
        return this.comments.reduce((group, comment) => {
          if (comment.is_read) {
            group[comment.date_group] = [
              ...(group[comment.date_group] || []),
              comment,
            ];

            console.log(group);
            return group;
          } else {
            group["New"] = [...(group["Unread"] || []), comment];
            return group;
          }
        }, {});
      }
      return this.comments;
    },
    unreadComments() {
      return this.comments.filter((comment) => {
        return !comment.is_read;
      });
    },
  },
  data() {
    return {
      loading: true,
      submittingComment: false,
      keepersUsers: [],
      mentions: [],
      comments: [],
      companyName: "",
      userMenuPosition: {
        top: 0,
        left: 0,
      },
      showUserMenu: false,
      form: {
        body: "",
      },
      isSearchingForUsers: false,
      currentMention: "",
      indexOfOngoingMention: -1,
      indexOfLastMention: 0,
      footerIncreaseAmount: 20,
    };
  },
  mounted() {
    this.fetchComments();

    this.$eventBus.$on('searchBegin', (index) => {
      this.searchBegin(index);
    })
    this.$eventBus.$on('searchEnd' ,(data) => {
      this.searchEnd();
    })
  },
  methods: {
    fetchComments() {
      axios
        .get(`/dashboard/admin/comments/${this.companyId}`)
        .then((response) => {
          this.comments = [];
          this.comments = response.data.comments.slice().sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
          this.companyName = response.data.company.name;
          this.loading = false;
          this.form.body = "";
          this.submittingComment = false;

          this.$nextTick(() => {
            this.$refs.comments_container.scrollTop =
              +this.$refs.comments_container.scrollHeight;
          });
        });
    },
    addNewComment() {
      if (this.isSearchingForUsers && !this.showUserMenu) {
          this.$eventBus.$emit("searchEnd", " ");
          return;
      }
      this.submittingComment = true;
      axios
        .post(`/dashboard/admin/comments/${this.statusId}`, {
          body: this.form.body,
          mentions: this.mentions,
          company_id: this.companyId,
        })
        .then((response) => {
          this.fetchComments();
          this.resetFooter()
        })
        .catch((err) => {
          this.submittingComment = false;
        });
    },
    replace(string, replace) {
      return string.replaceAll(replace, "");
    },
    getCursorPosition(e) {
      // We’re getting the caret coordinates of the input field.
      let caret = getCaretCoordinates(e.target, e.target.selectionEnd);

      // We’re getting the value of the input field.
      let value = e.target.value;
      let valueArray = value.split(" ");

      if (!value.includes("@")) {
        this.mentions = [];
      }

      // If the input field contains an “@” character, we’re opening the user menu.
       if (valueArray[valueArray.length - 1].includes("@") || this.isSearchingForUsers) {
        this.userMenuPosition.top = caret.top + "px";
        this.userMenuPosition.left = caret.left + "px";

        // We’re toggling the visibility of the user menu.
        this.showUserMenu = true;
      } else {
        // We’re toggling the visibility of the user menu.
        this.showUserMenu = false;
      }
    },
    mentionUser(userName, userEmail) {
      let value = this.$refs.commentForm.value;
      let valueArray = value.split(" ");
      this.mentions.push(userEmail);
      valueArray[this.indexOfOngoingMention] = `@${userName}`; // This puts the user and remove everything after it.
      valueArray.length = this.indexOfOngoingMention + 1;

      this.form.body = valueArray.join(" ").trim();
      this.removeUnMentionedUsers();
      this.showUserMenu = false;
      this.keepersUsers = [];
      this.$refs.commentForm.focus();
      this.indexOfLastMention = this.indexOfOngoingMention;
      this.resetMention();
    },
     searchBegin(index){
      this.indexOfOngoingMention = index;
      this.isSearchingForUsers = true;
    },
    searchEnd(){
      let user = this.keepersUsers[0];
      this.selectSearchedUser(user);
      this.mentionUser(this.replace(user.name, '| Keepers'), user.email);
    },
    resetMention(){
      this.isSearchingForUsers = false;
      this.currentMention = "";
      this.indexOfOngoingMention = -1;
      this.showUserMenu = false;
    },
    startMentionEvent(formBodyArray, searchTerm){
      let searchTermAsArray = searchTerm.split("");
      if(searchTermAsArray.indexOf("@") !== 0) {
        return;
      }
      if(!this.isSearchingForUsers){
        this.$eventBus.$emit('searchBegin', formBodyArray.indexOf(searchTerm, 0));
      }
    },
     isSearchTermEmpty(searchTerm, bodyAfterLastMention){
      if (searchTerm === ""){
        return bodyAfterLastMention[0];
      }
      // If the searchTerm is empty, we replace it with a default value to get all employees in the company.
      if (searchTerm.replace("@", "").trim() === ""){
        return "-1";
      }
      return searchTerm
    },
    newLine(){
      this.form.body = this.form.body + "\n";
      const textarea = document.getElementById('textArea');
      const footer = document.getElementById('footerTextArea');
      const end = textarea.value.length;
      textarea.setSelectionRange(end, end);
      textarea.focus();
      // Increase footer size by 20 px
      footer.style.height=footer.offsetHeight + this.footerIncreaseAmount + 'px'
    },
    resetFooter(){
      const footer = document.getElementById('footerTextArea');
      footer.style.height = footer.style.minHeight;
    },
    getUsers(searchTerm){
      return axios
        .get(`/keepers-employees/get/${searchTerm.replace("@", "").trim()}/${this.companyId}`)
        .then((res) => {
          this.keepersUsers = res.data;
        });
    },
    removeUnMentionedUsers(){
      this.getUsers('-1').then(res =>{
        let indexesToBeRemoved = [];
        for (let i = 0; i < this.mentions.length; i++) {
          let mentionEmail = this.mentions[i];
          let user = this.keepersUsers.find(element => element.email === mentionEmail);
          let splitBody = this.form.body.split('@');
          if(!splitBody.includes(user.name)){
            indexesToBeRemoved.push(i)
          }
        }
        for (let i = 0; i < indexesToBeRemoved.length; i++) {
          let indexToBeRemoved = indexesToBeRemoved[i];
          this.mentions.splice(indexToBeRemoved, 1);
        }
      });
    },
    enterUserSelector(){
      if(this.showUserMenu){
        this.$refs.userSelectorMenu.focus();
      }
    },
    previousElement(){
      if(this.showUserMenu){
        let activeElement = document.activeElement;
        let previousElement = activeElement.previousElementSibling;
        if(previousElement === null){
          this.$refs.userSelectorMenu.children[this.$refs.userSelectorMenu.children.length - 1].focus();
        } else {
          previousElement.focus();
        }
      }
    },
    nextElement(){
      if(this.showUserMenu){
        let activeElement = document.activeElement;
        let nextElement = activeElement.nextElementSibling;
        if(nextElement === null){
          this.$refs.userSelectorMenu.children[0].focus();
        } else {
          nextElement.focus();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.comments {
  background: white;
  position: fixed;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 24px 0;
  width: 90%;
  height: 90%;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  max-width: 800px;
  max-height: 800px;

  .comments-container {
    overflow: auto;
    height: calc(100% - 60px);
  }

  .header {
    height: 40px;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    padding: 0 24px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      margin-bottom: 16px;
      cursor: pointer;
    }
  }

  .footer {
    height: 45px;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    background-color: #fff;
    margin-top: auto;
    position: absolute;
    width: 100%;
    bottom: 0;
    display: flex;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    max-height: 300px;
    min-height: 45px;

    textarea {
      padding: 0 24px;
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid #0000001f;
      border-bottom-left-radius: 5px;

      &:focus {
        outline: none;
      }
    }

    .user-selector {
      position: absolute;
      left: var(--left);
      bottom: var(--top);
      margin-bottom: 20px;
      background: #fff;
      padding: 10px 0px;
      visibility: hidden;
      text-align: left;
      border-radius: 5px;
      box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 6px 3px rgb(0 0 0 / 5%);
      &.visible {
        visibility: visible;
      }

      li {
        max-width: none;
        padding: 5px 10px;
        cursor: pointer;
        border-radius: 0;

        &:hover {
          background-color: #f5f5f5;
        }
        &:focus {
          background-color: #f5f5f5;
          outline: none;
        }
      }
    }

    button {
      display: flex;
      position: absolute;
      bottom: 0;
      right: 0;
      max-height: 45px;
      min-width: 45px;
      height: 45px;
      border-radius: 5px !important;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0 24px;

    &.skeleton-loader {
      padding: 24px 24px;

      .other-author,
      .author_is_current {
        margin-bottom: 20px;
      }
    }
  }

  li {
    display: block;
    padding: 20px;
    border-radius: 30px;
    font-family: Helvetica, Arial, sans-serif;
    max-width: 50%;
  }

  .other-author {
    background: #eee;
    margin-left: 0;
    margin-right: auto;
  }

  .author_is_current {
    background: #0084ff;
    color: #fff;
    margin-right: 0px;
    margin-left: auto;
    padding-bottom: 10px;
  }

  .other-author + .author_is_current {
    border-bottom-right-radius: 5px;
  }

  .author_is_current + .author_is_current {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .author_is_current:last-of-type {
    border-bottom-right-radius: 30px;
  }
}

.modal-background {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: 0.4;
  z-index: 5;
}

svg {
  width: 20px;
}

.empty-comment {
  height: 24px;
  width: 100%;
  float: left;
}

.group-divider {
  text-align: center;
  color: rgba(0, 0, 0, 0.12);
  margin-top: 25px;
  margin-bottom: 25px;
  position: sticky;
  background-color: #fff;
  top: 0;
  z-index: 10;
  &::after,
  &::before {
    content: "";
    width: 45%;
    background-color: rgba(0, 0, 0, 0.12);
    position: absolute;
    top: 50%;
    height: 1px;
  }

  &::after {
    right: 0px;
  }

  &::before {
    left: 0px;
  }
}
</style>